import React from 'react';
import { Input, Modal } from 'antd';
import EditorComponent from 'component/ck_editor_component';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { EmailContentWarp, EmailSubmittWarp, Label } from './style';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { AntToggleButton } from 'component/form_component/style';

export default function EmailTemplateModal({
  id,
  handleMessageChange,
  subject,
  message,
  handleSubmit,
  apiLoading,
  visible,
  onClose,
  selectedRowData,
  handleSubjectChange,
  patternError,
  notifyUser,
  notifyDays,
  setNotifyDays,
  setNotifyUser,
}) {
  return (
    <Modal
      className='modal-style af-superadmin-template-modal'
      open={visible}
      onCancel={onClose}
      width={700}
      maskClosable={false}
      footer={[null]}
      centered
    >
      {apiLoading && <ModalOpenLoader />}
      <div className='af-superadmin-template-editbox-wrap'>
        <h2 className='af-superadmin-template-editbox-head'>Email Template</h2>
        <h3 className='af-superadmin-template-editbox-subhead'>{selectedRowData.templateName}</h3>
        <EmailContentWarp className='af-superadmin-template-editbox-content-subject'>
          <Label className='af-superadmin-template-editbox-content-subject-label'>Subject</Label>
          <Input
            className='af-superadmin-template-editbox-content-subject-input'
            value={subject}
            onChange={(e) => handleSubjectChange(e.target.value)}
          />
          {patternError && <span className='error-message'>{patternError}</span>}
        </EmailContentWarp>
        <EmailContentWarp className='af-superadmin-template-editbox-content-message'>
          <Label className='af-superadmin-template-editbox-content-message-label'>Message</Label>
          <div className='af-superadmin-template-editbox-content-message-ck'>
            <EditorComponent value={message} onChange={handleMessageChange} />
          </div>
        </EmailContentWarp>
        <EmailContentWarp className='af-superadmin-template-editbox-content-shortcode'>
          <h3 className='af-superadmin-template-editbox-content-shortcode-label' style={{ marginBottom: '0px' }}>
            Short Code options
          </h3>
          <p
            style={{ fontSize: '15px', marginTop: '0px' }}
            className='af-superadmin-template-editbox-content-shortcode-names'
          >
            {`{Sam-Name},{Display-Name},{UPN},{First-Name},{Last-Name}${
              [1, 2, 8, 9, 10].includes(id) ? ',{Link},{BaseUrl}' : ''
            }`}
          </p>
        </EmailContentWarp>
        <EmailSubmittWarp
          $expiry_notify={[9, 10].includes(id)}
          className='af-superadmin-template-editbox-content-buttonwrap'
        >
          {[9, 10].includes(id) && (
            <div className='af-superadmin-template-notify-wrap'>
              <div className='af-superadmin-template-notify-toggle-wrap'>
                <h3 className='af-superadmin-template-notify-toggle-label'>Notify User</h3>
                <AntToggleButton
                  onChange={(checked) => {
                    setNotifyUser(checked);
                  }}
                  checked={notifyUser}
                  className='af-form-switch af-superadmin-template-notify-toggle'
                />
              </div>
              <div className='af-superadmin-template-notifyperiod-input-wrap'>
                <h3 className='af-superadmin-template-notifyperiod-input-label'>
                  Notify {id === 9 ? 'After' : 'Before'}: (days)
                </h3>
                <Input
                  onChange={(e) => {
                    if ([9, 10].includes(id)) {
                      setNotifyDays(e.target.value);
                    }
                  }}
                  value={notifyDays}
                  className='af-form-switch af-superadmin-template-notifyperiod-input'
                />
              </div>
            </div>
          )}

          <StyledButton
            $expiry_notify={[9, 10].includes(id)}
            type='primary'
            onClick={handleSubmit}
            className='af-superadmin-template-editbox-content-button'
          >
            Save
          </StyledButton>
        </EmailSubmittWarp>
      </div>
    </Modal>
  );
}
